import React from 'react'
import { View } from 'react-native'
import Svg, { Path, Circle } from 'react-native-svg'

const PhotoUploadIcon = ({ color, height, width }) => {
    return (
        <View>
            <Svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox="0 0 24 24"
                fill="none"
            >
                <Path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.0186 7.49541C2 8.22358 2 9.05225 2 10V12H10.0971C9.76426 11.8433 9.40022 11.74 9.01534 11.7015L7 11.5H6.99999C5.68663 11.3687 5.02995 11.303 4.49718 11.087C3.36574 10.6283 2.50574 9.67803 2.1619 8.50656C2.0787 8.22308 2.03826 7.91099 2.0186 7.49541ZM21.8742 5.77457L21.5 17C20.5396 17 19.6185 16.6185 18.9393 15.9393L17.8123 14.8123C17.4423 14.4423 17.2572 14.2572 17.0697 14.1385C16.4165 13.7251 15.5835 13.7251 14.9303 14.1385C14.7428 14.2572 14.5577 14.4423 14.1877 14.8123L13.4145 15.5855C12.8925 16.1075 12 15.7378 12 14.9996V22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V10C22 8.20744 22 6.8409 21.8742 5.77457Z"
                    fill={color}
                />
                <Path
                    d="M10 3H14C15.9139 3 17.2487 3.00229 18.2559 3.1377C19.2342 3.26923 19.7521 3.50989 20.1211 3.87891C20.4901 4.24792 20.7308 4.7658 20.8623 5.74414C20.9977 6.75127 21 8.08611 21 10V14C21 15.9139 20.9977 17.2487 20.8623 18.2559C20.7308 19.2342 20.4901 19.7521 20.1211 20.1211C19.7521 20.4901 19.2342 20.7308 18.2559 20.8623C17.2487 20.9977 15.9139 21 14 21H13V14C13 13.5569 13.0018 13.124 12.9541 12.7695C12.909 12.4344 12.8078 12.0577 12.54 11.7256L12.4141 11.5859L12.2744 11.46C11.9423 11.1922 11.5656 11.091 11.2305 11.0459C10.876 10.9982 10.4431 11 10 11H3V10C3 8.08611 3.00229 6.75127 3.1377 5.74414C3.26923 4.7658 3.50989 4.24792 3.87891 3.87891C4.24792 3.50989 4.7658 3.26923 5.74414 3.1377C6.75127 3.00229 8.08611 3 10 3Z"
                    stroke={color}
                    strokeWidth={2}
                />
                <Circle cx="16" cy="8" r="2" fill={color} />
                <Path
                    d="M8 16V15H9V16H8ZM3.62469 20.7809C3.19343 21.1259 2.56414 21.056 2.21913 20.6247C1.87412 20.1934 1.94404 19.5641 2.37531 19.2191L3.62469 20.7809ZM7 21V16H9V21H7ZM8 17H3V15H8V17ZM8.6247 16.7809L3.62469 20.7809L2.37531 19.2191L7.3753 15.2191L8.6247 16.7809Z"
                    fill={color}
                />
            </Svg>
        </View>
    )
}

export default PhotoUploadIcon
